(function () {
  'use strict';

  /* ---------------- Vitrina animada: pausa fuera de viewport ---------------- */
  function initWallPause() {
    var walls = document.querySelectorAll('[data-fac-wall]');
    if (!walls.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scope = entry.target.closest('.fx-acc-scope');
        if (!scope) return;
        if (entry.isIntersecting) {
          scope.classList.remove('fac-wall-paused');
        } else {
          scope.classList.add('fac-wall-paused');
        }
      });
    }, { threshold: 0.05 });
    walls.forEach(function (w) { io.observe(w); });
  }

  /* ---------------- Swatches: image-swap en desktop (sin navegar) ---------------- */
  function initSwatches() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.fac-swatch');
      if (!btn) return;
      e.preventDefault();
      var img = btn.getAttribute('data-fac-variant-image');
      var card = btn.closest('.fac-card') || btn.closest('.fac-media')?.closest('a');
      var mediaImg = btn.parentElement && btn.parentElement.parentElement
        ? btn.parentElement.parentElement.querySelector('.fac-media__img')
        : null;
      if (img && mediaImg) {
        mediaImg.setAttribute('src', img);
      }
      var group = btn.closest('[data-fac-swatches]');
      if (group) {
        group.querySelectorAll('.fac-swatch').forEach(function (s) {
          s.setAttribute('aria-pressed', 'false');
        });
      }
      btn.setAttribute('aria-pressed', 'true');
    });
  }

  /* ---------------- Sort dropdown (desktop panel fiel al prototipo) ----------------
     Bind único por root (guard data-fac-sort-bound): el panel se sustituye por un nodo
     nuevo en cada swap AJAX, así que el listener se registra UNA sola vez sobre el
     `root` persistente y busca el panel vivo en cada click, en vez de cerrar sobre una
     referencia que quedaría obsoleta tras el primer filtro aplicado. */
  function initSortDropdown(root) {
    if (root.dataset.facSortBound) return;
    root.dataset.facSortBound = 'true';

    function close(panel) {
      panel.classList.remove('is-open');
      root.querySelectorAll('[data-fac-sort-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      }, 150);
    }

    function open(panel, toggleBtn) {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    root.addEventListener('click', function (e) {
      var panel = root.querySelector('[data-fac-sort-panel]');
      if (!panel) return;
      var toggle = e.target.closest('[data-fac-sort-toggle]');
      if (toggle) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          close(panel);
        } else {
          open(panel, toggle);
        }
        return;
      }
      if (!e.target.closest('[data-fac-sort-panel]') && panel.classList.contains('is-open')) {
        close(panel);
      }
    });

    document.addEventListener('keydown', function (e) {
      var panel = root.querySelector('[data-fac-sort-panel]');
      if (panel && e.key === 'Escape' && panel.classList.contains('is-open')) close(panel);
    });
  }

  /* ---------------- Drawer de filtros (desktop panel / mobile bottom sheet) ---------------- */
  function initDrawer(root) {
    var drawer = root.querySelector('[data-fac-drawer]');
    var overlay = root.querySelector('[data-fac-drawer-overlay]');
    if (!drawer || !overlay) return;

    var lastFocused = null;

    function getFocusable() {
      return drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }

    function trap(e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      var mainContent = document.querySelector('main') || document.body;
      Array.prototype.forEach.call(document.body.children, function (child) {
        if (!drawer.contains(child) && !overlay.contains(child) && child !== drawer && child !== overlay) {
          if (child.contains(drawer) || child.contains(overlay)) return;
          child.setAttribute('data-fac-inert-applied', 'true');
          child.setAttribute('inert', '');
        }
      });
      var focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.querySelectorAll('[data-fac-inert-applied]').forEach(function (el) {
        el.removeAttribute('inert');
        el.removeAttribute('data-fac-inert-applied');
      });
      document.removeEventListener('keydown', onKeydown);
      setTimeout(function () {
        drawer.hidden = true;
        overlay.hidden = true;
      }, 260);
      /* El botón que abrió el drawer puede haberse sustituido en un swap AJAX del toolbar */
      if (lastFocused && lastFocused.isConnected) {
        lastFocused.focus();
      } else {
        var opener = root.querySelector('[data-fac-open-drawer]');
        if (opener) opener.focus();
      }
    }

    /* 2026-10-08: único cierre válido (limpia inert + listener). initFilterNav lo usa al
       aplicar filtros; antes cerraba por su cuenta y dejaba header/carrito/footer inertes. */
    root._facCloseDrawer = function () {
      if (!drawer.hidden) close();
    };

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
      } else {
        trap(e);
      }
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-fac-open-drawer]')) open();
      else if (e.target.closest('[data-fac-drawer-close]')) close();
    });
    overlay.addEventListener('click', close);
  }

  /* ---------------- Cargar más (Section Rendering API + history.pushState) ----------------
     Bind único por root (guard data-fac-loadmore-bound): el wrap se sustituye por un nodo
     nuevo en cada swap, así que se busca en vivo dentro del handler en vez de cerrar sobre
     una referencia que quedaría obsoleta. */
  function initLoadMore(root) {
    if (root.dataset.facLoadmoreBound) return;
    root.dataset.facLoadmoreBound = 'true';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fac-loadmore-btn]');
      if (!btn) return;
      var loadMoreWrap = btn.closest('[data-fac-loadmore]');
      if (!loadMoreWrap) return;
      e.preventDefault();

      var url = btn.getAttribute('href');
      var sectionId = loadMoreWrap.getAttribute('data-section-id');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Cargando…';

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-fac-grid]');
          var currentGrid = root.querySelector('[data-fac-grid]');
          var newLoadMore = doc.querySelector('[data-fac-loadmore]');

          if (newGrid && currentGrid) {
            var newItems = newGrid.querySelectorAll('[data-fac-grid-item]');
            var firstNewItem = null;
            newItems.forEach(function (item, idx) {
              currentGrid.appendChild(item);
              if (idx === 0) firstNewItem = item;
            });

            if (firstNewItem) {
              firstNewItem.setAttribute('tabindex', '-1');
              var liveRegion = document.getElementById('fac-live-region');
              if (liveRegion) {
                liveRegion.textContent = newItems.length + ' productos nuevos cargados.';
              }
            }
          }

          if (newLoadMore) {
            loadMoreWrap.outerHTML = newLoadMore.outerHTML;
          } else {
            loadMoreWrap.remove();
          }

          window.history.pushState({}, '', url);
        })
        .catch(function () {
          window.location.href = url;
        });
    });
  }

  function initLiveRegion() {
    if (document.getElementById('fac-live-region')) return;
    var el = document.createElement('div');
    el.id = 'fac-live-region';
    el.setAttribute('aria-live', 'polite');
    el.className = 'visually-hidden';
    document.body.appendChild(el);
  }

  /* ---------------- Tabs/chips/sort/drawer: filtrado sin salir de la plantilla ----------------
     Reutiliza el mismo patrón de Section Rendering API + history.pushState que ya usa
     initLoadMore (no construye un segundo sistema). Los href/action ya llegan desde Liquid
     con view=accesorios preservado (snippets/fx-acc-preserve-view.liquid) — este JS solo evita
     que naveguen a página completa, para que hero/toolbar no se desmonten. Sigue funcionando
     sin JS: cada href/action ya es una URL válida por sí misma (fallback real, no decorativo).
  ---------------------------------------------------------------------------------------------- */
  /* .fac-brand vive en fx-acc-hero.liquid, una <section> que el swap de
     abajo NUNCA reemplaza (solo toca el catálogo) — así que su estado
     "activo" hay que sincronizarlo aparte, en cliente, comparando el
     data-fac-vendor de cada botón contra filter.p.vendor de la URL destino.
     Se llama tanto al hacer clic como al navegar con atrás/adelante. */
  function syncBrandActiveState(url) {
    var targetVendor = '';
    try {
      var qs = new URLSearchParams(url.indexOf('?') > -1 ? url.split('?')[1] : '');
      targetVendor = (qs.get('filter.p.vendor') || '').toLowerCase();
    } catch (err) {
      targetVendor = '';
    }
    document.querySelectorAll('.fac-brand[data-fac-vendor]').forEach(function (a) {
      var isActive = a.getAttribute('data-fac-vendor') === targetVendor;
      a.classList.toggle('is-active', isActive);
      if (isActive) {
        a.setAttribute('aria-current', 'page');
      } else {
        a.removeAttribute('aria-current');
      }
    });
  }

  function initFilterNav(root) {
    if (!root.hasAttribute('data-fac-catalog-section')) return;
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    function closeDrawerIfOpen() {
      if (typeof root._facCloseDrawer === 'function') root._facCloseDrawer();
    }

    /* Conserva ?view= (plantilla alternativa) en URLs construidas en cliente */
    function withView(url) {
      try {
        var view = new URLSearchParams(window.location.search).get('view');
        if (!view || /[?&]view=/.test(url)) return url;
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=' + encodeURIComponent(view);
      } catch (err) {
        return url;
      }
    }

    /* URL de un form de filtros sin parámetros vacíos (precio sin rellenar) */
    function formUrl(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      var qs = params.toString();
      return form.getAttribute('action') + (qs ? '?' + qs : '');
    }

    /* Marca: sustituye (no suma) el vendor activo sobre la URL actual, conservando el
       resto de filtros, el orden y la vista. Pulsar la marca activa vuelve a "Ver todos". */
    function brandUrl(link) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('filter.p.vendor');
        u.searchParams.delete('page');
        u.searchParams.delete('section_id');
        var value = link.getAttribute('data-fac-vendor-value');
        if (value && !link.classList.contains('is-active')) u.searchParams.append('filter.p.vendor', value);
        return u.pathname + (u.search || '');
      } catch (err) {
        return link.getAttribute('href');
      }
    }

    function swap(url, skipPush, keepDrawerOpen) {
      url = withView(url);
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      var wasDrawerOpen = keepDrawerOpen && drawerIsOpen();

      syncBrandActiveState(url);

      return fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newToolbar = doc.querySelector('[data-fac-toolbar]');
          var curToolbar = root.querySelector('[data-fac-toolbar]');
          if (newToolbar && curToolbar) curToolbar.replaceWith(newToolbar);

          var newResults = doc.querySelector('[data-fac-catalog-results]');
          var curResults = root.querySelector('[data-fac-catalog-results]');
          if (newResults && curResults) curResults.replaceWith(newResults);

          var newDrawerForm = doc.querySelector('#fac-filters-form');
          var curDrawerForm = root.querySelector('#fac-filters-form');
          if (newDrawerForm && curDrawerForm) {
            /* El contador ("Ver N productos") vive dentro de este form y se recalcula
               server-side en cada fetch — al reemplazar el innerHTML siempre queda
               representando el resultado real de los filtros ya seleccionados, incluso
               cuando el drawer permanece abierto tras marcar un checkbox (wasDrawerOpen). */
            curDrawerForm.innerHTML = newDrawerForm.innerHTML;
          }

          /* Re-inicializa lo que referenciaba nodos ahora reemplazados (sort panel vive
             dentro del toolbar; loadmore vive dentro de los resultados). El drawer/overlay
             en sí no se reemplazan (solo el contenido del form), así que no hace falta
             reabrir su listener. */
          initSortDropdown(root);
          initLoadMore(root);

          if (!skipPush) window.history.pushState({ facUrl: url }, '', url);

          var countEl = root.querySelector('.fac-grid-count, .fac-toolbar-mobile__count');
          var liveRegion = document.getElementById('fac-live-region');
          if (liveRegion) {
            liveRegion.textContent = countEl ? countEl.textContent.trim() + ' actualizado.' : 'Resultados actualizados.';
          }

          if (!wasDrawerOpen) closeDrawerIfOpen();
        })
        .catch(function () {
          window.location.href = url;
        });
    }

    function drawerIsOpen() {
      var drawer = root.querySelector('[data-fac-drawer]');
      return !!(drawer && !drawer.hidden);
    }

    /* .fac-brand vive en fx-acc-hero.liquid, un <section> distinto del catálogo (root aquí)
       — no es descendiente de root, así que este listener se delega en document para
       capturarlo también. El resto de controles (.fac-tab, chips, sort…) sí son
       descendientes de root; delegar en document los sigue capturando igual. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest(
        '.fac-tab, .fac-brand, .fac-chip, .fac-chip-clear, .fac-sort-option, .fac-btn-clear, [data-fac-catalog-results] .fac-btn-navy'
      );
      if (!link) return;
      var href = link.classList.contains('fac-brand') ? brandUrl(link) : link.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      swap(href, false);
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('#fac-filters-form');
      if (!form) return;
      e.preventDefault();
      swap(formUrl(form), false);
    });

    /* Checkboxes/precio dentro del drawer: aplican en vivo (sin cerrar el drawer) para que
       "Ver N productos" represente siempre el resultado real de los filtros ya marcados,
       igual que el estado en memoria del prototipo — sin esto, el contador se quedaba con
       el valor de la última carga completa hasta pulsar el botón de submit. */
    root.addEventListener('change', function (e) {
      var field = e.target.closest('#fac-filters-form input[type="checkbox"], #fac-filters-form input[type="number"]');
      if (!field) return;
      var form = field.closest('#fac-filters-form');
      if (!form) return;
      swap(formUrl(form), false, true);
    });

    window.addEventListener('popstate', function () {
      swap(window.location.href, true);
    });

    /* Estado inicial de las marcas según la URL real (enlaces compartidos, recargas, volver) */
    syncBrandActiveState(window.location.href);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWallPause();
    initSwatches();
    initLiveRegion();
    document.querySelectorAll('.fx-acc-scope').forEach(function (root) {
      initDrawer(root);
      initLoadMore(root);
      initSortDropdown(root);
      initFilterNav(root);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.fx-acc-scope') : null;
    if (root) {
      initDrawer(root);
      initLoadMore(root);
      initSortDropdown(root);
      initFilterNav(root);
    }
  });
})();
